import styled from 'styled-components';
import { Menu } from 'antd';

export const StyledMenu = styled(Menu)`
  line-height: 64px;
  padding-left: 20px;
`;
